module.exports = __webpack_public_path__ + "img/sweden-cerebrovascular-disease-male.3cce4402.png";